import { OnInit, Output, EventEmitter, Directive } from '@angular/core';
import { PatchValue } from '@app/shared/components/base/base-patch.component';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { OpData } from '@app/core/services/base/base-service-with-bundle.service';

@Directive()
export class UpdateComponent extends BaseComponent implements OnInit  {

    @Output()
    public updated = new EventEmitter<PatchValue>();

    @Output()
    public multiUpdated = new EventEmitter<OpData[]>();

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
    }
 
    public onChange(propertyName: string, value: any): void {
        this.updated.emit({
            propertyName: propertyName,
            value: value
        });
    }

    public onMultiUpdate(opData: OpData[]): void {
        this.multiUpdated.emit(opData);
    }
}
